<template>
  <div class="card">
    <div class="card-body">
      <form @submit.prevent="createUnitExperience">
        <!--@submit.prevent="createProduct" to trigger event when click "submit"-->
        <div>
          <multiselect
            v-model="unitExperience.experience"
            tag-placeholder="Add this as new tag"
            :taggable="true"
            @tag="addTag"
            @update="updateSelected"
            :searchable="true"
            :close-on-select="true"
            label="name"
            track-by="id"
            :placeholder="$t('selectOneExperience')"
            :options="productNames"
            :option-height="104"
          >
            <template slot="singleLabel" slot-scope="props"
              ><img
                class="option_image"
                :src="`${props.option.img_path}`"
                alt="image"
              /><span class="option_title"
                ><span class="option_title">{{ props.option.name }}</span></span
              ></template
            >
            <template slot="option" slot-scope="props"
              ><img
                class="option_image"
                :src="`${props.option.img_path}`"
                alt="image"
              />
              <div class="option_title">
                <span>{{ props.option.name }}</span>
              </div>
            </template>
          </multiselect>
          <!-- <pre class="language-json"><code>{{ productName  }}</code></pre> -->
          <br />
        </div>

        <!-- <BaseInput
          class="field"
          v-model="unitExperience.stock_max"
          type="number"
          :placeholder="$t('maxStock')"
          :class="{ error: $v.unitExperience.stock_max.$error }"
          @blur="$v.unitExperience.stock_max.$touch()"
        />

        <template v-if="$v.unitExperience.stock_max.$error">
          <p v-if="!$v.unitExperience.stock_max.required" class="errorMessage">
            {{ $t('maxStockReq') }}
          </p>
        </template> -->
        <!--Form validation-->

        <!-- <div class="optionalData">
          <p class="optional">{{ $t('optional') }}</p>
          <b-form-textarea
            class="field form-control"
            aria-label="With textarea"
            v-model="unitExperience.comments"
            maxlength="300"
            type="text"
            :placeholder="$t('unitProductComm')"
          ></b-form-textarea>
        </div> -->

        <!-- <ImgUpload /> -->
        <button
          type="submit"
          buttonClass="-fill-gradient"
          :disabled="$v.$anyError"
          class="add-btn"
        >
          {{ $t('add') }}
        </button>
        <p v-if="$v.anyError" class="errorMessage">
          {{ $t('fillInReq') }}
        </p>
      </form>
    </div>
    <sweet-modal
      icon="error"
      title="Oh nooo…"
      name="errorModal"
      ref="modalError"
    >
      {{ $t('errorMsg') }}
      <sweet-button slot="button">{{ $t('tryAgain') }}</sweet-button>
    </sweet-modal>
  </div>
</template>

<script>
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import NProgress from 'nprogress'
// import ProductService from '@/services/ProductService.js'
// import ImgUpload from '@/components/ui/ImgUpload.vue'
import { required } from 'vuelidate/lib/validators'

export default {
  components: {
    // ImgUpload,
    Multiselect,
  },
  data() {
    return {
      productNames: [],
      productName: [],
      unitExperience: this.createFreshUnitExperienceObject(),
      selectedFile: null,
      unit: [],
      baseUrl: process.env.VUE_APP_API_URL,
    }
  },
  validations: {
    unitExperience: {
      experience: { required },
      comments: {},
    },
  },
  mounted() {
    this.createFreshUnitExperienceObject()
    axios
      .get(
        `${process.env.VUE_APP_API_URL}/available/experiences/unit/` +
          this.unitExperience.unit.id
      )
      .then((response) => (this.productNames = response.data))
  },

  methods: {
    createUnitExperience() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        NProgress.start()
        this.$store
          .dispatch('experience/createUnitExperience', this.unitExperience)
          .then(() => {
            this.$router.push({
              name: 'unitExperience',
              params: {
                unitId: this.unitExperience.unit.id,
                experienceId: this.unitExperience.experience.id,
              },
            })
          })
          .catch(() => {
            NProgress.done()
            this.$refs.modalError.open()
          })
      }
    },
    createFreshUnitExperienceObject() {
      const client = this.$store.state.client.client
      const unit = this.$store.state.unit.unit
      const id = Math.floor(Math.random() * 1000000)

      return {
        id: id,
        client: client,
        unit: unit,
        product: '',
        comments: '',
        experience: '',
        // unit_productImage: ''
      }
    },
    updateSelected: function (newSelected) {
      this.selected = newSelected
    },
    addTag: function (newTag) {
      this.productNames.push(newTag)
      this.selected.push(newTag)
    },
  },
}
</script>

<style scoped>
@import '../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css';

textarea {
  height: 180px;
}

.optionalData {
  background-color: var(--grey-light);
  border: 1px solid var(--grey);
  padding: 0 20px;
  width: 100%;
}
.optional {
  text-align: center;
  letter-spacing: 5px;
  color: var(--bg);
}

.card-body {
  color: #454655;
}
.field {
  margin-bottom: 24px;
}

.card-title {
  font-size: 30px;
}
p {
  text-align: left;
}
.errorMessage {
  font-size: 0.8em;
  margin-top: -10px;
  color: var(--primaryDark);
}

.add-btn {
	margin-top: 1em;
	background: var(--primaryDark);
	color: var(--bright);
	padding: 0.5em;
	letter-spacing: 3px;
	border-radius: 5px;
	width: 80%;
	text-transform: uppercase;
}

.option_image {
  height: 50px;
  width: 50px;
  display: inline;
}

.option_title {
  display: inline;
  margin-left: 5px;
}

@media screen and (max-width: 560px) {
  button {
    padding: 10px 60px 10px 60px;
  }
  form {
    width: 100%;
  }
  .optionalData {
    padding: 10px;
  }
  textarea {
    width: 100%;
    height: 100px;
  }
}
</style>
